// extracted by mini-css-extract-plugin
export default {"wrap":"referencesComments_wrap__9sPdu","message":"referencesComments_message__znmWf","hr":"referencesComments_hr__hlQss","chatText":"referencesComments_chatText__D3tBs"};